// extracted by mini-css-extract-plugin
module.exports = {"faq":"__9-faq_faq__VFrYv","faqWrap":"__9-faq_faqWrap__42RcZ","faqList":"__9-faq_faqList__qUA0o","faqItem":"__9-faq_faqItem__O19Cw","itemTitle":"__9-faq_itemTitle__IQnpn"};